export enum UserStatusEnum {
  Active = 1,
  LockedOut = 3,
  Blocked = 6,
}
